import { render, staticRenderFns } from "./profileButton.vue?vue&type=template&id=81794fe8&"
import script from "./profileButton.vue?vue&type=script&lang=ts&"
export * from "./profileButton.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports